import { ReactNode } from "react";
import { Container } from "react-bootstrap";

import Body from "../Body";
import Main from "../Main";
import Sidebar from "../Sidebar";

type LayoutProps = {
	children: ReactNode;
};

export default function Layout({ children }: LayoutProps) {
	return (
		<Container fluid className="layout" style={{ minHeight: "100vh" }}>
			<Body>
				<Sidebar />
				<Main>{children}</Main>
			</Body>
		</Container>
	);
}
